import type { Component } from 'solid-js'
import type { IconProps } from './icon'

const Music: Component<IconProps> = (props) => {
  const size = () => props.size ?? 12

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class={`size-${size()} rounded-lg`}>
      <rect width="48" height="48" fill="#F3F4F6" rx="8" />
      <path
        d="M31.2939 13.5287C31.52 13.4641 31.7634 13.5094 31.9512 13.6508C32.1391 13.7925 32.25 14.0151 32.25 14.2504V28.3031C32.2499 29.6424 31.3619 30.8189 30.0742 31.1869L28.7539 31.5649C27.1232 32.0305 25.5 30.8057 25.5 29.1098C25.5001 27.9701 26.2557 26.9688 27.3516 26.6557L29.6621 25.9955C30.306 25.8116 30.7499 25.2227 30.75 24.5531V18.9945L21.75 21.5658V31.3031C21.7499 32.6424 20.8619 33.8189 19.5742 34.1869L18.2539 34.5649C16.6232 35.0305 15 33.8057 15 32.1098C15.0001 30.9701 15.7557 29.9688 16.8516 29.6557L19.1621 28.9955C19.806 28.8116 20.2499 28.2227 20.25 27.5531V17.2504C20.25 16.9155 20.472 16.6207 20.7939 16.5287L31.2939 13.5287Z"
        fill="#99A1AF"
      />
    </svg>
  )
}

export default Music
